import React, { useEffect, useState } from 'react';
import { Logger } from '../tools/logger';

export const Alert = () => {
  const [messages, setMessages] = useState([])
  const [currentMessage, setCurrentMessage] = useState('')
  const [visible, setVisible] = useState(false)
  const addMessage = (message) => {
    setMessages((messages) => [...messages, message])
  }
  Logger.alert.call = addMessage;
  window.Logger = Logger
  useEffect(() => {
    if (!visible && messages.length) {
      setVisible(true)
    }
  }, [messages.length, visible])
  const next = () => {
    const nextMessages = [...messages];
    const message = nextMessages.shift()
    setCurrentMessage(message)
    setMessages(nextMessages)
    setVisible(!!message)
  }
  useEffect(() => {
    if (!currentMessage && messages.length) {
      next()
    }
  }, [messages.length, currentMessage])
  const onClick = () => next()
  console.log('alert', { visible, currentMessage, messages })
  if (!visible || !currentMessage) {
    return null
  }
  return <div className={'alert'} style={styles.alert}>
    <span>{currentMessage}</span>
    <button onClick={onClick}>OK</button>
  </div>
}

const styles = {
  alert: {
    position: 'fixed',
    top: '5px',
    left: '5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    maxWidth: '70%',
    zIndex: 99999999,
    flex: 1,
    backgroundColor: 'black',
    color: 'white',
    padding: '10px',
  }
}